import { createSelector } from 'reselect';

import { RequestState, StateDictionary } from './utils/state-manager';

type UsersByIdDictionary = { [username: string]: User };
type UsersDictionary = { [orgId: number]: User[] };

export type UserState = {
  usersById: UsersByIdDictionary;
  usersStateByAccountId: StateDictionary;
  usersByOrgId: UsersDictionary;
  usersByOrgIdStatus: StateDictionary;
  adminUsersStatus: RequestState;
  adminUsers: User[];
};
type State = { users: UserState };

const usersByIdSelector = (state: State) => state.users.usersById;
export const userForUsernameSelector = createSelector(
  [usersByIdSelector, (_state: State, username: string) => username],
  (usersById, username) => usersById[username],
);
export const usersForAccountIdSelector = createSelector(
  [usersByIdSelector, (_state: State, accountId: number) => accountId],
  (usersById, accountId) => Object.values(usersById).filter((user) => user.accountId === accountId),
);

const usersStateByAccountIdStateSelector = (state: State) => state.users.usersStateByAccountId;
export const usersStateForAccountIdSelector = createSelector(
  [usersStateByAccountIdStateSelector, (_state: State, accountId: number) => accountId],
  (usersStateByAccountId, accountId) => usersStateByAccountId[accountId],
);

const usersByOrgIdSelector = (state: State) => state.users.usersByOrgId;
export const usersForOrgIdSelector = createSelector(
  [usersByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (usersByOrgId, orgId) => usersByOrgId[orgId],
);
const usersByOrgIdStatusSelector = (state: State) => state.users.usersByOrgIdStatus;
export const usersForOrgIdStatusSelector = createSelector(
  [usersByOrgIdStatusSelector, (_state: State, orgId: number) => orgId],
  (usersByOrgIdStatus, orgId) => usersByOrgIdStatus[orgId],
);

export const adminUsersStatusSelector = (state: State) => state.users.adminUsersStatus;
export const adminUsersSelector = (state: State) => state.users.adminUsers;
